import { ProFormFieldProps } from '@ant-design/pro-form/es/components/Field';
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { Fields_imgcode } from '../imgcode';
import styles from './style.module.less';
@inject((store) => store)
@observer
@BindAll()
export class Fields_captcha_group extends React.Component<
  ProFormFieldProps & {
    imgcodeName?: string;
    phoneName?: string;
    scene: Number; //场景 ：1：注册；2：短信登录；3：忘记密码；4：校验旧手机号，5：绑定新手机号
    onClearImgCode: () => {};
    large: boolean;
    type: string;
    onSendMsg?: (params) => {};
    [key: string]: any;
  }
> {
  imgCodeRef = React.createRef<Fields_imgcode>();
  state = {
    countDown: 60,
    imgSession: null,
    imgCode: null,
    timer: null,
    t: null,
  };
  get Currency() {
    return this.$Store.Currency;
  }
  get formState() {
    return this.props.formState;
  }
  get imgcodeName() {
    return this.props.imgcodeName || 'imgCode';
  }
  get phoneName() {
    return this.props.phoneName || 'mobile';
  }
  get phoneNumber() {
    return this.props.phoneNumber;
  }
  get scene() {
    return this.props.scene;
  }
  // get isShowImgCode() {
  //   return lodash.eq(this.props.isShowImgCode, false) ? false : true
  // }
  // @Debounce(500, {leading:false, trailing: true })
  onRestImgcode() {
    this.imgCodeRef.current.getImgCode();
    this.props.onClearImgCode();
    this.setState({ imgCode: null });
  }

  // 获取短信验证码
  async onGetCaptcha(phone) {
    if (!this.state.imgCode) {
      React.Antd.message.warning('请输入图形验证码！');
      throw new Error('请输入图形验证码');
    }
    try {
      if (this.props.onSendMsg) {
        await this.props.onSendMsg({
          imgCode: this.state.imgCode,
          imgSession: this.state.imgSession,
        });
      } else {
        const res = await this.Currency.sendCode({
          endpoint: phone,
          imgCode: this.state.imgCode,
          receiverType: React.$Mamba.EnumCaptchaType.mobile,
          scene: this.scene,
          imgSession: this.state.imgSession,
          t: this.state.t,
        });
        React.Antd.message.success(`获取验证码成功${res ? res : ''}`);
      }
      setTimeout(() => {
        // this.onRestImgcode()
        if (this.imgCodeRef.current) {
          this.imgCodeRef.current.getImgCode();
        }
      }, this.state.countDown * 1000);
    } catch (error) {
      this.onRestImgcode();
      throw new Error('获取验证码错误');
    }
  }

  onImgCodeChange(e) {
    this.setState({ imgCode: e.target.value });
  }
  onSessionChange(value) {
    this.setState({ imgSession: value });
  }
  onTChange(value) {
    this.setState({ t: value });
  }
  componentDidMount() {
    console.log('LENG ~ captcha ~ componentDidMount', this.props);
  }
  render() {
    return (
      <div className={styles.captchaGroup}>
        <div className={styles.imgcode}>
          <Fields_imgcode
            type={this.props.type}
            ref={this.imgCodeRef}
            name={this.imgcodeName}
            onChange={this.onImgCodeChange}
            onSessionChange={this.onSessionChange}
            large={this.props.large}
            onTChange={this.onTChange}
          />
        </div>
        <div className={this.props.large ? styles.largeCaptcha : ''}>
          <React.Antd.ProFormCaptcha
            countDown={this.state.countDown}
            placeholder={'请输入验证码'}
            captchaProps={{
              type: 'primary',
              ghost: true,
            }}
            captchaTextRender={(timing, count) => {
              // if (lodash.eq(count, 1)) {
              //   lodash.once(this.onRestImgcodeKey)
              // }
              if (timing) {
                return `${count} ${'s后重新获取'}`;
              }
              return '获取验证码';
            }}
            phoneName={this.phoneName}
            onGetCaptcha={async (phone) => {
              await this.onGetCaptcha(phone);
            }}
            {...(lodash.omit(this.props, 'extra') as any)}
          />
        </div>
      </div>
    );
  }
}
